import React from 'react'
import Button from '../../../../shared/src/components/atoms/button/button'
import './modalContinuarDiagnosticoCompleto.scss'
import heartIcon from '../../../../assets/corazon.svg'
import { useNavigate } from 'react-router-dom'

const ModalContinuarDiagnosticoCompleto = () => {

	const navigate = useNavigate();

	return (
		<div className="continuar-diagnostico-completo-modal">
			<img src={heartIcon} alt="" />
			<h2>¡Perfecto!</h2>
			<p>Para ayudarte a construir tus sueños te invitamos a completar el diagnóstico financiero</p>
			<Button gtmClass='secondary' onClick={() => navigate('/formulario-salud-educacion-financiera/')}>Continuar</Button>
		</div>
	)
}

export default ModalContinuarDiagnosticoCompleto